import React from 'react';
import { cn } from '@bem-react/classname';

import './CodeBlockWrapper.scss';

export const CnCodeBlockComponent = cn('code-block-component');

export const CodeBlockWrapper: React.FC = ({ children }) => <ol className={CnCodeBlockComponent()}>{children}</ol>;
